<template>
<v-container class="pb-0">
  <!-- Headline -->
  <v-row>
    <v-col>
      <h1>Was oft lange vorher<br> seinen Anfang nahm.</h1>
    </v-col>
  </v-row>

  <v-row>
    <v-col>
      <p>
        Ein schwieriges Jahr, eine Kostenüberschreitung bei einer Investition, ein größerer Zahlungsausfall. <strong>Ein unvorhergesehenes Ereignis bringt die Firma aus dem Gleichgewicht.</strong> Erste finanzielle Probleme sind spürbar. Viele versuchen selbst, mit dieser Situation fertig zu werden. Die finanziellen Probleme hindern Sie zunehmend daran, sich um das Tagesgeschäft kümmern zu können. Umsätze und Erträge gehen zurück. Wo vermeintlich ein Loch geschlossen wird, tun sich zwei neue auf.
      </p>
      <hr>

      <h3>Wenn Ihnen das alles bekannt vorkommt, sollten Sie sich dieses Video ansehen!</h3>
      <div class="video-container">
        <iframe src="https://player.vimeo.com/video/435665636?app_id=122963" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
// import vuePlayer from '@algoz098/vue-player' REENABLE THIS WHEN VIDEO GET'S CHANGED

export default {
  components: {
    // vuePlayer REENABLE THIS COMPONENT IF VIDEO GET'S CHANGED AGAIN
  }
}

</script>
<style scoped lang="scss">

  .row-beratung {
    text-align: center;

    img {
      width: 58px;
      margin: 0 auto;
      display: block;
    }

    .center-me {
      margin: 0 auto 1.22rem auto;
    }

    .border-right {
      border-right: solid 2px $orange-yellow;
    }

    a {
      font-family: $second-font-family;
      font-size: 1.67rem;
      font-weight: 700;
      text-decoration: none;
      color: $orange-yellow;
    }

    .v-card {
      display: inline-block;

      &.big-card {
        display: block;

        .row {
          text-align: center;
        }
      }
    }
  }

  .video-container {
    display: block;
    max-width: calc(780px + 24px);
    margin: 0 auto;

    iframe {
      width: 100%;
      min-height: 400px;
    }
  }

  h3 {
    font-weight: 900;
    line-height: 1.33;
    letter-spacing: .18px;
    color: #262f5c;
    margin-top: 1.5em;
    margin-bottom: 1.94em;
    font-size: 1rem;
  }

  .video-links {
    a {
      font-size: .944rem;
      font-weight: 700;
      line-height: 1.47;
      letter-spacing: .17px;
      color: #f49e00;
      text-decoration: none;
    }
  }

  // Container Spacing
  .container {
    padding-top: 6.78rem;
    padding-bottom: 2rem;
    position: inherit;
    background-color: $white;
    z-index: 10;
    max-width: 100%;

    .row {
      max-width: 760px;
    }
  }

  h1 {
    color: $sapphire;
    margin-left: 0;
  }

  p,
  li {
    color: $dark-grey-blue;
  }

  p {
    &.text-blue {
      color: $sapphire;
    }
  }

  @media screen and (max-width: 1263px) {
    .container {
      padding-top: 2.11rem;
      padding-bottom: 2.11rem;
      margin-bottom: 3.66rem;
    }

    h1 {
      margin-left: 0;
    }

    p {
      &.text-blue {
        max-width: 100%;
      }
    }
  }

  @media screen and (max-width: 765px) {
    .container {
      margin-bottom: 1.66rem;
    }
  }

  @media screen and (max-width: 700px) {
    .video-container {
      iframe {
        min-height: 300px;
      }
    }
  }
</style>
